import Vue from 'vue'
import Vuex from 'vuex'
import { customerModule } from './modules/customer.module'
import { onboardingModule } from './modules/onboarding.module'
import { errorModule } from './modules/errors.module'
import { uboEnrollModule } from './modules/uboEnroll.module'
import { multiBusinessModule } from './modules/multiBusiness.module'
import i18n from '../i18n'

// Delete after refactor done
// Old ob module
import { onBoardingModule } from '../store/modules/ob.module'

Vue.use(Vuex)

const Store = new Vuex.Store({
  state: {
    locale: 'en',
    customerDetails: customerModule,
    progressFillWidth: window.screen.width < 500 ? '15%' : '10%',
    messages: i18n.messages,
    notice: null,
    validation: null,
    backDialog: false,
    backDialogConfirmed: false,
    timeout: false,
    restart: false,
    done: false,
    forceRefresh: false,
    fromRoute: '',
  },
  mutations: {
    // Old mutations ** delete after refactore **
    setFillWidth(state, width) {
      state.progressFillWidth = width
    },
    setFromRoute(state, fromRoute) {
      state.fromRoute = fromRoute
    },
    setLocal(state, lang) {
      state.locale = lang
    },
    setNotice(state) {
      state.notice = i18n.messages[state.locale].notice
    },
    setValidation(state) {
      state.validation = i18n.messages[state.locale].validation
    },
    makeDialogVisible(state) {
      state.backDialog = true
    },
    makeDialogHidden(state) {
      state.backDialog = false
    },
  },
  getters: {
    // Old getters - ** Delete after redactor **
    geti18(state) {
      return state.messages[state.locale]
    },
    getFromRoute(state) {
      return state.fromRoute
    },
  },
  modules: {
    customer: customerModule,
    onboarding: onboardingModule,
    errors: errorModule,
    uboEnroll: uboEnrollModule,
    multiBusiness: multiBusinessModule,
    // Old ob module
    ob: onBoardingModule,
  },
})

// Expose Store to be access by this.$store to vue components
export default () => {
  return Store
}

// Expose Store instance to be available for importing to non-vue component
export { Store }



// WEBPACK FOOTER //
// ./src/RF_store/index.js